import React from 'react'

// theme
import aampeTheme from '../../constants/aampeTheme'

// images
import globalErrorImage from '../../images/globalErrorImage.svg?react'

// components
import BasicSection from '../display/layout/basicSection'

export default function GlobalError() {
    return (
        <BasicSection
            style={{
                borderRadius: aampeTheme.borderRadius.default,
                margin: aampeTheme.spacing4(4, 2, 8, 4),
                padding: aampeTheme.spacing4(14, 4, 12),
            }}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <img alt={'placeholder'} src={globalErrorImage} />

                <h1
                    style={{
                        marginTop: aampeTheme.spacing4(8),
                        color: aampeTheme.colors.blue900,
                    }}
                >
                    {'Something went wrong.'}
                </h1>

                <p
                    style={{
                        marginTop: aampeTheme.spacing4(4),
                        textAlign: 'center',
                        color: aampeTheme.colors.blue900,
                    }}
                >
                    {
                        'Thanks for helping us beta test. We’ll get these bugs taken care of quick.'
                    }
                </p>
            </div>
        </BasicSection>
    )
}
